import React from 'react';
import {
  number, func, bool, string, arrayOf
} from 'prop-types';

import QuestionText from '../QuestionText';
import { questionType, responseOptionType } from '../../constants/types';
import styles from './dropDownQuestion.module.css';
import sharedStyles from '../../styles/shared';
import { getTranslation } from '../../i18n';

const SelectionQuestion = ({
  orderNum, question, onChange, errorState, lang, responseOptions, answer, translate
}) => {
  const handleChange = (event) => {
    onChange(event.target.name, event.target.value !== ''
      ? Number(event.target.value) : null);
  };

  const questionId = question.id;
  const questionElementId = `question_${question.id}`;
  const errorId = `err_${questionId}`;

  return (
    <div
      aria-labelledby={questionElementId}
      aria-required={question.required || undefined}
      aria-invalid={errorState && question.required ? 'true' : undefined}
      aria-describedby={errorState ? errorId : undefined}
      className={`${sharedStyles.row} ${sharedStyles.questionRow}`}
    >
      <QuestionText
        id={questionElementId}
        errorId={errorId}
        showError={errorState && question.required}
        question={question}
        orderNum={orderNum}
        lang={lang}
        translate={translate}
      />
      <div className={styles.col}>
        <select
          className={styles.select}
          name={questionId}
          onChange={handleChange}
          defaultValue={answer || ''}
        >
          <option value="" disabled={question.required}>{translate('common.dropdown.prompt')}</option>
          {responseOptions.map((responseOption) => {
            const optionId = `${questionId}_${responseOption.id}`;
            return (
              <option key={optionId} value={responseOption.value}>
                {getTranslation(responseOption.text, lang)}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

SelectionQuestion.propTypes = {
  orderNum: number.isRequired,
  question: questionType.isRequired,
  onChange: func.isRequired,
  errorState: bool,
  lang: string.isRequired,
  responseOptions: arrayOf(responseOptionType).isRequired,
  answer: number,
  translate: func.isRequired
};

SelectionQuestion.defaultProps = {
  answer: null,
  errorState: false
};

export default SelectionQuestion;
